module.exports = "https://web-assets.ifttt.com/packs/media/partners/close-fa8d6d80.svg";